var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2003 5.16572L16.4472 18.9064H12.6892L9.85981 7.94432C9.6857 7.26962 9.5406 7.02296 9.01825 6.74002C8.16218 6.27571 6.75474 5.84042 5.51416 5.57199L5.60122 5.16572H11.6445C12.457 5.16572 13.1463 5.76061 13.2768 6.5659L14.7713 14.5172L18.4786 5.17297H22.2003V5.16572ZM36.9204 14.4229C36.9349 10.7955 31.9073 10.5996 31.9436 8.97451C31.9508 8.48118 32.4224 7.95883 33.4526 7.82099C34.6569 7.70491 35.8684 7.9153 36.9567 8.43039L37.5806 5.51395C36.5141 5.11493 35.3896 4.90454 34.2579 4.90454C30.7465 4.90454 28.2726 6.76904 28.2509 9.44607C28.2291 11.4194 30.0138 12.5294 31.3632 13.1823C32.7489 13.857 33.2132 14.2851 33.2059 14.8872C33.1987 15.8086 32.1032 16.2148 31.0802 16.2294C29.2956 16.2584 28.2581 15.7433 27.4311 15.3588L26.7854 18.3695C27.6124 18.7468 29.1505 19.0805 30.7393 19.095C34.461 19.124 36.8986 17.274 36.9204 14.4229ZM46.1993 18.8991H49.4858L46.6201 5.16572H43.5803C42.9129 5.15846 42.3107 5.56473 42.0641 6.18139L36.7318 18.8991H40.4608L41.2008 16.846H45.7641L46.1993 18.8991ZM42.2309 14.0384L44.1027 8.8802L45.1764 14.0384H42.2309ZM27.2787 5.16572L24.3405 18.8991H20.7856L23.7238 5.16572H27.2787Z",
    fill: "#1C32C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c16faca20466eea431f4f821dae4089d.svg";
export { ForwardRef as ReactComponent };